import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { metaSchemas } from "@/lib/constants";
import LogicaAPI from "./logicaapi";
class Episodes extends LogicaAPI {
  async getEpisode(id) {
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: {
        meta_schema_id: metaSchemas.episode.id,
        meta_id: id,
        "values.adult_flag": false
      }
    });
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  nextEpisode(id) {
    const params = {
      sort: "num",
      order: "asc",
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      datasource: "decorator"
    };
    return this.get(`/api/v1/metas/${id}/next`, {
      params
    });
  }
}
export default Episodes;